import Resource from '@/api/resources/Resource'

/**
    * @deprecated You must use the new service that is located in "configuration/centersAndAreas/center/configuration-center-services.ts"
    */
class ConfigurationCenterServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/centers`, filterModel, { params })
        return response.data
    }
    async getCentersByName(params) {
        const response = await this.axios.get(`/configuration/centers/search`, { params })
        return response.data
    }
    async patchCentersBatch(centers) {
        const response = await this.axios.patch(`/configuration/centers/batch`, centers)
        return response.data
    }
    async createCenter(center) {
        const response = await this.axios.post(`/configuration/centers`, center)
        return response.data
    }
    async deleteCentersBatch(centersIds) {
        const data = {
            entityIdentifiers: centersIds
        }
        const response = await this.axios.delete(`/configuration/centers/batch`, { data: data })
        return response.data
    }
}

export default new ConfigurationCenterServices()
